var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { size } from 'polished';
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';
import Icon from '../../common/components/Icon';
import cookieStorage from '../../common/CookieStorage';
import { useLocalization } from '../../common/providers/LocaleProvider';
import { NavigationGroup, NavigationItem } from './NavigationList';
import BottomNavigationLink from './BottomNavigationLink';
var ICON_SIZE = '22px';
var PaybackIcon = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), size(ICON_SIZE), space);
PaybackIcon.defaultProps = {
    mr: 'sp_4',
};
var BottomNavigationSection = function (_a) {
    var withPaybackLink = _a.withPaybackLink;
    var _b = useLocalization(), t = _b.t, r = _b.r, p = _b.p;
    var _c = __read(useState(), 2), customer = _c[0], setCustomer = _c[1];
    useEffect(function () {
        setCustomer(cookieStorage.getCustomer());
    }, []);
    var _d = customer || {}, _e = _d.firstName, firstName = _e === void 0 ? '' : _e, _f = _d.isLoggedIn, isLoggedIn = _f === void 0 ? false : _f;
    var navigation = [
        isLoggedIn
            ? {
                label: r(t('h24_not_your_account'), {
                    username: firstName,
                }),
                href: p.t('h24_logout_url'),
            }
            : {
                label: t('h24_register'),
                href: p.t('h24_register_url'),
            },
        {
            label: t('h24_my_account'),
            href: p.t('h24_my_overview_url'),
        },
        {
            label: t('h24_help_contact'),
            href: p.t('h24_help_contact_url'),
        },
    ];
    if (withPaybackLink) {
        navigation.push({
            label: t('h24_payback'),
            href: p.t('h24_payback_page_url'),
            icon: React.createElement(PaybackIcon, { name: "paybackShort" }),
        });
    }
    return (React.createElement(NavigationGroup, null, navigation.map(function (item, index) { return (React.createElement(NavigationItem, { key: index, as: "li" },
        React.createElement(BottomNavigationLink, __assign({}, item)))); })));
};
export default React.memo(BottomNavigationSection);
var templateObject_1;
